import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "StatusTool" }




export default /*#__PURE__*/_defineComponent({
  __name: 'StatusTool',
  props: {
    direction: {
        type: String,
        required: true,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("i", {
      class: _normalizeClass('fa fa-arrow-' + __props.direction)
    }, null, 2)
  ]))
}
}

})